const NAVIGATION_PATH = {
  ORDERS: "/orders",
  MY_ORGANIZATION: "/myorganization",
  USERS: "/users",
  PAYMENT_PROFILE: "/paymentProfile",
  LOCATION: "/location",
  PROFILE: "/profile",
  CATEGORY_LIST: "/categorylist",
  USER_ASSIGNMENT: "/userAssignment",
  DEBUG_LOGS: "/debuglogs",
  TAKE_PAYMENT: "/takepayment",
  DASHBOARD: "/dashboard",
  INVENTORY_DASHBOARD: "/inventorydashboard",
  TRANSACTION: "/alltransactions",
  CASHLESS_PAYMENTS: "/cashlessPayments",
  CASH_PAYMENTS: "/cashPayments",
  FB_PAYMENTS: "/fbPayments",
  MEMBER_PAYMENTS: "/memberPayments",
  TRANSACTION_ITEMS: "/transactionitemsummary",
  FUNDRAISER_EVENTS: "/fundraiser/events",
  FUNDRAISER_USERS: "/fundraiser/users",
  DEVICE_REBOOT: "/devicereboot",
  LINK_PAY: "/linkpay",
  LOGIN: "/Login",
};

export default NAVIGATION_PATH;